export default __webpack_public_path__ + "static/media/Metamask.71e24f26.gif";